const splineKind = {
  CARDINAL_SPLINE: 'CARDINAL_SPLINE',
  KOCHANEK_SPLINE: 'KOCHANEK_SPLINE'
};
var Constants = {
  splineKind
};

export { Constants as default, splineKind };
